import Vue from 'vue'
import introJs from 'intro.js'
import 'intro.js/introjs.css';
import router from '../router/index'
import store from '../vuex/store'
import './http.js'
let count = 0 // 初始化为0，后面会根据每一步传入的dom的id选择器 判断当前在第几步
let state = 1 // skip: 0 ,done: 1；

export function guide (introSteps) {
  if (parseInt(sessionStorage.getItem('complete_guide'))) {
    return
  }
  introJs().setOptions({
    disableInteraction: true,
    steps: introSteps,
    /* 当位置选择自动的时候，位置排列的优先级 */
    positionPrecedence: ['top', 'bottom', 'right', 'left'],
    prevLabel: this.$t('messages.createCampaign.create109'),
    nextLabel: this.$t('messages.login.next'),
    skipLabel: this.$t('messages.gLogin.jump'),
    // 这里因为每个页面的最后一步其实就会显示doneLabel了，而实际上我们的新手引导操作并没有完成，需要跳转路由继续，所以显示的是下一步而非完成。
    doneLabel: this.$t('messages.login.next'), 
    hidePrev: true,
    exitOnOverlayClick: false,
    /* 是否显示说明的数据步骤*/
    showStepNumbers: false,
    /* 是否使用点点点显示进度 */
    showBullets: false,
    /* 是否使用键盘Esc退出 */
    exitOnEsc: false,
    /* 默认提示位置 */
    hintPosition: 'top-left',
    /* 说明高亮区域的样式 */
    highlightClass: 'customHighlight',
    /* 引导说明文本框的样式 */
    tooltipClass: 'customTooltip',
  }).onbeforechange(function (targetElement) {
  })
  .onchange(function (targetElement) {
    introJs().nextStep()
    // 每次change时触发，我的id样式是“guide-step<id>”
    // id代表新手引导的第几步，例如“guide-step1”，通过id判断当前是第几步
    count = parseInt(targetElement.id.slice(-1))
    store.state.introStepInfo.currentStep = count
    sessionStorage.setItem('currentStep', count)
  }).onafterchange(function (targetElement) {
    // 公司设计的新手引导只有七步，如果count == 7了，说明现在是最后一步
    // 跳转完成后用js的dom操作将doneLabel由“下一步”改为“完成”
    if(count !== 1){
      // 显示上一步按钮
      let previousButton = document.createElement('a')
      let tooltipButtons = document.querySelector('.introjs-tooltipbuttons')
      previousButton.innerText = this.$t('messages.createCampaign.create109');
      previousButton.href = 'javascript:void(0);'
      previousButton.classList.add('introjs-button','introjs-prevbutton')
      previousButton.role='button'
      previousButton.addEventListener('click', function() {
        let helperLayer = document.querySelector('.introjs-helperLayer')
        let tooltipReferenceLayer = document.querySelector('.introjs-tooltipReferenceLayer')
        let disableInteraction = document.querySelector('.introjs-disableInteraction')
        document.body.removeChild(helperLayer)
        document.body.removeChild(tooltipReferenceLayer)
        document.body.removeChild(disableInteraction)
        store.state.introStepInfo.currentStep = count-1
        sessionStorage.setItem('currentStep', count-1)
      });
      if(tooltipButtons){
        tooltipButtons.insertBefore(previousButton,tooltipButtons.firstChild)
      }
    }
    if (count === 7) {
      document.getElementsByClassName('introjs-donebutton')[0].innerHTML = 'Done'
    }
    // 禁止遮罩层下面元素的交互
    disableMaskInteraction('none');
  }).oncomplete(function (targetElement) {
    // 点击完成以及跳过按钮后执行的事件，不区分完成和跳过。
    state = 1
    setTimeout(() => {
      if (state) {
        judgeCount()
      }
    }, 200)
  }).onexit(function (targetElement) {
    if(count === 7){
      // 调接口，完成引导
      disableMaskInteraction()
      finishGuide()
    }
    // 点击完成按钮后， 执行的事件
  }).onskip(function (targetElement) {
    // 点击跳过按钮后， 执行的事件
    // onskip这个我当时在官网api里查不到，是我自己翻源码翻出来的，折腾半天，无语。
    // 因为点击跳过以后是默认完成了新手引导，此时就需要将状态传给后端，保证下一次进入有Intro.js的页面时时不加载新手引导了。
    // 因为vue是跨路由写的，每个页面的完成其实都不是用户真正完成了新手引导
    // 所以如果不区分完成和跳过各自触发的事件的话，我们就不会知道用户当前是跳过（ ==完成了新手引导）还是只是当前页面的完成，需要继续跳转下一个路由。
    state = 1
    // 存储进缓存，下次进入新手引导路由页时将不在触发Intro.js
    store.state.introStepInfo.complete_guide = state
    sessionStorage.setItem('complete_guide', state)
    // 调接口，完成引导
    disableMaskInteraction()
    finishGuide()
  }).start();
}

export function hideGuide(){
  if (parseInt(sessionStorage.getItem('complete_guide'))) {
    return
  }
  introJs().exit()
  disableMaskInteraction()
}

// 这个是每一步新手引导对应的点击下一步时对应应该进行的操作
// 我这边，1，2步在一个页面，3，4步在一个页面，5，6步在一个页面，第7步在一个页面
// 所以1，3，5的时候我不需要进行特定操作，按照Intro.js走就行了
function judgeCount () {
  // 这是事先预存的跳转路由需要的一些数据
  if(store.state.introStepInfo.complete_guide || parseInt(sessionStorage.getItem('complete_guide'))) return;
  if(count !== 7){
    store.state.introStepInfo.currentStep = count+1
    sessionStorage.setItem('currentStep', count+1)
  }
  switch (count) {
    case 1:
      router.push('/snapshot') 
      break
    case 2:
      break
    case 3:
      break
    case 4:
      router.push('/campaign/create')
      break
    case 5:
      router.push('/snapshot')
      break
    case 6:
      router.push('/deposit')
      break
    case 7:
      sessionStorage.setItem('complete_guide', 1)
      break
  }
}

function disableMaskInteraction(val='') {
  var elements = document.body.querySelectorAll(':not([class^= "introjs-" ])')
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.pointerEvents = val;
  }
}

function finishGuide(){
  Vue.prototype.$http
    .post('/api/accounts/profile/', {
      complete_guide:1,
    })
    .then(() => {
      store.commit('UPDATE_POP',store.getters.holidayNow)// changePop Status
    })
}

